module.exports = __webpack_public_path__ + "static/media/scopes-of-losses.6305c8cf.png";